<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1967 13.916H4.80318C4.00983 13.916 3.3667 14.5591 3.3667 15.3525V15.3536C3.3667 16.147 4.00983 16.7901 4.80318 16.7901H16.1967C16.9901 16.7901 17.6332 16.147 17.6332 15.3536V15.3525C17.6332 14.5591 16.9901 13.916 16.1967 13.916Z"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M16.1967 11.041H4.80318C4.00983 11.041 3.3667 11.6841 3.3667 12.4775V12.4786C3.3667 13.272 4.00983 13.9151 4.80318 13.9151H16.1967C16.9901 13.9151 17.6332 13.272 17.6332 12.4786V12.4775C17.6332 11.6841 16.9901 11.041 16.1967 11.041Z"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M16.1967 8.16797H4.80318C4.00983 8.16797 3.3667 8.8111 3.3667 9.60445V9.60557C3.3667 10.3989 4.00983 11.0421 4.80318 11.0421H16.1967C16.9901 11.0421 17.6332 10.3989 17.6332 9.60557V9.60445C17.6332 8.8111 16.9901 8.16797 16.1967 8.16797Z"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M13.6524 5.29492H7.34863"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.89237 10.0918H12.1075C12.4949 10.0918 12.8088 10.4057 12.8088 10.7931V16.6655H8.18994V10.7931C8.18994 10.4057 8.50389 10.0918 8.89124 10.0918H8.89237Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M1.89551 10.4953L9.66852 2.72231C10.1056 2.28527 10.8136 2.28527 11.2495 2.72231L19.105 10.5778"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M17.6953 3.5V9.11604"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
